import { makeAutoObservable } from 'mobx';

export class HosterUIModel {
  showSettingsModal: boolean = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  toggleSettingsModal() {
    this.showSettingsModal = !this.showSettingsModal;
  }
}
